import { FETCH_ALL_ROUTES } from '../actions'
import moment from 'moment'

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_ROUTES:
      if (action.payload.data && 'length' in action.payload.headers) {
        return {
          ...state,
          routes: action.payload.data.map((row) => {
            const time = moment.utc(row.createdAt).toDate()
            const local = moment(time).local().format('YYYY-MM-DD HH:mm:ss')
            return {
              ...row,
              createdAt: local,
            }
          }),
          length: Number(action.payload.headers.length),
        }
      } else return state

    default:
      return state
  }
}
